// src/features/records/services/edges/keys.js

export function getViewFlagKey(viewType) {
  switch (viewType) {
    case 'calendar':
      return 'hasDate';
    case 'task':
      return 'hasTask';
    case 'map':
      return 'hasLocation';
    case 'gallery':
      return 'hasMedia';
    default:
      return `has${viewType.charAt(0).toUpperCase()}${viewType.slice(1)}`;
  }
}

export function getQueryFieldKey(sortKey) {
  switch (sortKey) {
    case 'updatedAt':
      return 'recordUpdatedAt';
    case 'taskOrder':
      return 'taskOrder';
    case 'dueDate':
      return 'dueAt';
    case 'date':
      return 'startAt';
    case 'priority':
      return 'priority';
    default:
      return sortKey;
  }
}
